import BanzaiTransientbooksService from '@/services/banzai-transientbooks.service'
import {AxiosInstance} from 'axios'
import _Vue from 'vue'

let service: BanzaiTransientbooksService

export default {
  install (
    Vue: typeof _Vue,
    { http }: { http: AxiosInstance }) {
    service = new BanzaiTransientbooksService(http)
    Vue.prototype.$banzaiTransientBooks = service
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiTransientBooks: BanzaiTransientbooksService;
  }
}
